import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import { loadAwsConfig } from './aws-exports';

const root = ReactDOM.createRoot(document.getElementById('root'));

loadAwsConfig().then((config) => {
  Amplify.configure(config);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
